import * as tslib_1 from "tslib";
import { connectedAccountsStore } from '../store/store';
import getOAuth2AuthorizationEndpointInfoOperation from 'owa-service/lib/operation/getOAuth2AuthorizationEndpointInfoOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export function getAuthorizationUri() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var provider, uri, store, state, request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    provider = 4;
                    uri = window.location.protocol + "//" + window.location.hostname + "/mail/GetAuthorizationCode.html";
                    store = connectedAccountsStore();
                    state = btoa(JSON.stringify({
                        provider: 'google',
                        trf: store.connectGmailState.targetRootFolderEnabled ? 1 : 0,
                        sendonly: store.connectGmailState.isSendOnly ? 1 : 0,
                        displayname: store.connectGmailState.displayName,
                    }));
                    request = {
                        Header: getJsonRequestHeader(),
                        OAuthProvider: provider,
                        RedirectUri: uri,
                        State: state,
                    };
                    return [4 /*yield*/, getOAuth2AuthorizationEndpointInfoOperation(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=getAuthorizationUri.js.map